import { render, staticRenderFns } from "./commentDetailDrawer.vue?vue&type=template&id=4223370c&scoped=true"
import script from "./commentDetailDrawer.vue?vue&type=script&lang=js"
export * from "./commentDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./commentDetailDrawer.vue?vue&type=style&index=0&id=4223370c&prod&lang=scss&scoped=true"
import style1 from "./commentDetailDrawer.vue?vue&type=style&index=1&id=4223370c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223370c",
  null
  
)

export default component.exports